import 'css-chunk:src/carousel/carousel.module.scss';export default {
  "heading-xxl": "carousel-module__heading-xxl___zWQfT",
  "wrapper": "carousel-module__wrapper___dGCpA",
  "heading-xl": "carousel-module__heading-xl___nLFud",
  "heading-lg": "carousel-module__heading-lg___n1jT4",
  "heading-md": "carousel-module__heading-md___G90L8",
  "heading-sm": "carousel-module__heading-sm___-42Ru",
  "heading-xs": "carousel-module__heading-xs___u1Uzn",
  "body-one": "carousel-module__body-one___XM5Jo",
  "body-two": "carousel-module__body-two___ttWc-",
  "body-three": "carousel-module__body-three___Cks9Z",
  "body-four": "carousel-module__body-four___1BD5u",
  "overline-one": "carousel-module__overline-one___RhuZp",
  "overline-two": "carousel-module__overline-two___cFVxe",
  "overline-three": "carousel-module__overline-three___NwW62",
  "strong": "carousel-module__strong___FoUMU",
  "em": "carousel-module__em___M--DJ",
  "figcaption": "carousel-module__figcaption___WOlda",
  "no-margin": "carousel-module__no-margin___siaOs",
  "carouselWrapper": "carousel-module__carouselWrapper___fJX8v",
  "navArrowWrapper": "carousel-module__navArrowWrapper___ltKKd",
  "swiperNavPrev": "carousel-module__swiperNavPrev___nsU4S",
  "swiperNavNext": "carousel-module__swiperNavNext___Iglwp",
  "swiperPagination": "carousel-module__swiperPagination___xlIn1",
  "carousel": "carousel-module__carousel___aiob4"
};